import { z } from "zod";

export const Supplier = z.object({
    id: z.string(),
    name: z.string(),
    commissionAgreement: z.string(),
    description: z.string(),
    website: z.string(),
});

export type Supplier = z.infer<typeof Supplier>;
